import Vue from 'vue'
import Utils from './Utils'

export default {

  ping (haslo) {
    return Vue.http.post('ping', haslo).then(null, Utils.przechwycBlad)
  }
}
